/* L2 · Quiz "Encuentra tu fórmula" · lógica reutilizable (página + modal) */
(function () {
  if (window.L2Quiz) return; // evita doble carga (sección + modal global)
  var VALID = ['mujer', 'peso', 'vista', 'piel', 'antiedad', 'dolor', 'general'];

  function init(root, opts) {
    if (!root) return null;
    opts = opts || {};
    var modal = !!opts.modal;
    var quiz = root.hasAttribute && root.hasAttribute('data-quiz') ? root : root.querySelector('[data-quiz]');
    if (!quiz) return null;
    if (quiz.getAttribute('data-quiz-ready') === '1') {
      // ya inicializado: solo reinicia al objetivo pedido
      if (quiz.__l2quiz) quiz.__l2quiz.restart(opts.goal);
      return quiz.__l2quiz;
    }
    quiz.setAttribute('data-quiz-ready', '1');

    var tierOn = quiz.getAttribute('data-tier') === '1';
    var named = {
      goal: quiz.querySelector('[data-step="goal"]'),
      refine: quiz.querySelector('[data-step="refine"]'),
      tier: quiz.querySelector('[data-step="tier"]'),
      result: quiz.querySelector('[data-step="result"]'),
      analyzing: quiz.querySelector('[data-step="analyzing"]')
    };
    var profiles = Array.prototype.slice.call(quiz.querySelectorAll('[data-step="profile"]'));
    var P = profiles.length;
    var tierPossible = tierOn && !!quiz.querySelector('[data-has-pack="1"]');
    var totalSteps = 3 + P + (tierPossible ? 1 : 0);
    var bar = quiz.querySelector('[data-quiz-bar]');
    var back = quiz.querySelector('[data-quiz-back]');
    var state = { goal: null, outcome: null, hasPack: false, tier: null, profile: {}, pIdx: 0, screen: 'goal' };

    function allSteps() {
      return [named.goal, named.refine, named.tier, named.result, named.analyzing].concat(profiles).filter(Boolean);
    }
    function reveal(el) {
      el.hidden = false; el.classList.add('is-enter');
      requestAnimationFrame(function () { requestAnimationFrame(function () { el.classList.remove('is-enter'); }); });
    }
    function scrollTop() {
      if (modal) {
        var dlg = quiz.closest('dialog');
        var sc = dlg ? (dlg.querySelector('[data-quiz-modal-content]') || dlg) : null;
        if (sc) { try { sc.scrollTo({ top: 0, behavior: 'smooth' }); } catch (e) { sc.scrollTop = 0; } }
      } else {
        try {
          var y = quiz.getBoundingClientRect().top + window.pageYOffset - 72;
          window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
        } catch (e) { try { quiz.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e2) {} }
      }
    }
    function go(el, screen, stepNum) {
      if (!el) return;
      state.screen = screen;
      allSteps().forEach(function (s) { s.hidden = true; });
      reveal(el);
      if (bar) bar.style.width = Math.min(100, Math.round(stepNum / totalSteps * 100)) + '%';
      if (back) back.hidden = (screen === 'goal' || screen === 'analyzing');
      scrollTop();
      try {
        var hd = el.querySelector('.l2-quiz__q,.l2-quiz__result-eyebrow,.l2-quiz__analyzing-t');
        if (hd) { hd.setAttribute('tabindex', '-1'); hd.focus({ preventScroll: true }); }
      } catch (e) {}
    }
    function showGroup(goal) {
      quiz.querySelectorAll('[data-refine-group]').forEach(function (g) { g.hidden = (g.getAttribute('data-refine-group') !== goal); });
    }
    function markSelected(btn) {
      if (!btn || !btn.parentNode) return;
      btn.parentNode.querySelectorAll('.l2-quiz__opt').forEach(function (b) { b.classList.remove('is-selected'); });
      btn.classList.add('is-selected');
    }
    function showProfile(i) { state.pIdx = i; go(profiles[i], 'profile', 3 + i); }
    function afterQuestions() {
      if (tierOn && state.hasPack) { go(named.tier, 'tier', 3 + P); }
      else { analyzeThenResult(); }
    }
    function analyzeThenResult() {
      if (named.analyzing) { go(named.analyzing, 'analyzing', totalSteps); setTimeout(finishResult, 900); }
      else { finishResult(); }
    }
    function finishResult() {
      var id = state.outcome;
      quiz.querySelectorAll('[data-result]').forEach(function (r) { r.hidden = (r.getAttribute('data-result') !== id); });
      var card = quiz.querySelector('[data-result="' + id + '"]');
      if (card) {
        card.querySelectorAll('[data-card]').forEach(function (c) { c.classList.remove('is-reco'); });
        var want = (state.tier === 'pack') ? 'pack' : 'single';
        var reco = card.querySelector('[data-card="' + want + '"]') || card.querySelector('[data-card="single"]');
        if (reco) reco.classList.add('is-reco');
        var rec = card.querySelector('[data-quiz-recap]');
        if (rec) {
          var vals = Object.keys(state.profile).map(function (k) { return state.profile[k]; });
          if (vals.length) { rec.textContent = vals.join(' · '); rec.hidden = false; } else { rec.hidden = true; }
        }
      }
      go(named.result, 'result', totalSteps);
    }
    function goBack() {
      if (state.screen === 'result') {
        if (tierOn && state.hasPack) { go(named.tier, 'tier', 3 + P); }
        else if (P > 0) { showProfile(P - 1); }
        else { go(named.refine, 'refine', 2); }
      } else if (state.screen === 'tier') {
        if (P > 0) { showProfile(P - 1); } else { go(named.refine, 'refine', 2); }
      } else if (state.screen === 'profile') {
        if (state.pIdx > 0) { showProfile(state.pIdx - 1); } else { go(named.refine, 'refine', 2); }
      } else {
        go(named.goal, 'goal', 1);
      }
    }
    function restart(goal) {
      state.goal = state.outcome = state.tier = null; state.hasPack = false; state.profile = {}; state.pIdx = 0;
      quiz.querySelectorAll('.is-selected').forEach(function (b) { b.classList.remove('is-selected'); });
      if (goal && VALID.indexOf(goal) >= 0 && quiz.querySelector('[data-refine-group="' + goal + '"]')) {
        state.goal = goal; showGroup(goal);
        var gb = quiz.querySelector('[data-goal-pick="' + goal + '"]'); if (gb) gb.classList.add('is-selected');
        go(named.refine, 'refine', 2);
      } else {
        go(named.goal, 'goal', 1);
      }
    }

    quiz.addEventListener('click', function (e) {
      var g = e.target.closest('[data-goal-pick]');
      if (g) { state.goal = g.getAttribute('data-goal-pick'); markSelected(g); showGroup(state.goal); setTimeout(function () { go(named.refine, 'refine', 2); }, 150); return; }
      var o = e.target.closest('[data-outcome-pick]');
      if (o) {
        state.outcome = o.getAttribute('data-outcome-pick'); state.hasPack = o.getAttribute('data-has-pack') === '1'; state.tier = null; markSelected(o);
        setTimeout(function () { if (P > 0) { showProfile(0); } else { afterQuestions(); } }, 150); return;
      }
      var pf = e.target.closest('[data-profile-pick]');
      if (pf) {
        var st = pf.closest('[data-step="profile"]'); var key = st ? st.getAttribute('data-profile-key') : ('p' + state.pIdx);
        state.profile[key] = pf.getAttribute('data-profile-pick'); markSelected(pf);
        setTimeout(function () { if (state.pIdx + 1 < P) { showProfile(state.pIdx + 1); } else { afterQuestions(); } }, 150); return;
      }
      var t = e.target.closest('[data-tier-pick]');
      if (t) { state.tier = t.getAttribute('data-tier-pick'); markSelected(t); setTimeout(analyzeThenResult, 150); return; }
      if (e.target.closest('[data-quiz-restart]')) { restart(null); return; }
      if (e.target.closest('[data-quiz-back]')) { goBack(); return; }
    });

    quiz.addEventListener('submit', function (e) {
      var f = e.target.closest('[data-quiz-email]'); if (!f) return;
      e.preventDefault();
      var input = f.querySelector('[data-quiz-email-input]');
      var email = input && input.value.trim();
      if (!email || email.indexOf('@') < 0) { if (input) input.focus(); return; }
      var card = f.closest('[data-result]');
      var rb = card && card.querySelector('.is-reco [data-quiz-product]');
      var pt = rb || (card && card.querySelector('[data-quiz-product]'));
      var prod = pt ? pt.getAttribute('data-quiz-product') : '';
      var props = { objetivo: state.goal, producto: prod, tier: state.tier || 'single' };
      Object.keys(state.profile).forEach(function (k) { props['perfil_' + k] = state.profile[k]; });
      try {
        if (window.klaviyo && window.klaviyo.push) { window.klaviyo.push(['identify', { '$email': email }]); window.klaviyo.push(['track', 'Quiz Completado', props]); }
        else if (window._learnq) { window._learnq.push(['identify', { '$email': email }]); window._learnq.push(['track', 'Quiz Completado', props]); }
      } catch (err) {}
      var klCompany = quiz.getAttribute('data-kl-company');
      var klList = quiz.getAttribute('data-kl-list');
      if (klCompany && klList) {
        try {
          fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(klCompany), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
            body: JSON.stringify({ data: { type: 'subscription', attributes: { custom_source: 'Quiz Encuentra tu fórmula', profile: { data: { type: 'profile', attributes: { email: email, properties: props } } } }, relationships: { list: { data: { type: 'list', id: klList } } } } })
          });
        } catch (err) {}
      }
      var ok = f.querySelector('[data-quiz-email-ok]'); if (ok) ok.hidden = false;
      if (input) input.disabled = true;
      var btn = f.querySelector('button[type="submit"]'); if (btn) btn.disabled = true;
    });

    // Arranque: objetivo por opts o por query (?goal=) en la página standalone
    var dg = opts.goal;
    if (!dg && !modal) { try { dg = new URLSearchParams(window.location.search).get('goal'); } catch (e) {} }
    if (dg && VALID.indexOf(dg) >= 0 && quiz.querySelector('[data-refine-group="' + dg + '"]')) {
      state.goal = dg; showGroup(dg);
      var gb0 = quiz.querySelector('[data-goal-pick="' + dg + '"]'); if (gb0) gb0.classList.add('is-selected');
      go(named.refine, 'refine', 2);
    }

    var api = { restart: restart, el: quiz };
    quiz.__l2quiz = api;
    return api;
  }

  window.L2Quiz = { init: init };

  // Auto-init de la página standalone
  function auto() {
    document.querySelectorAll('[data-quiz]:not([data-quiz-ready])').forEach(function (q) { init(q); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', auto);
  else auto();
})();
